import { render, staticRenderFns } from "./experience.vue?vue&type=template&id=49b10de6"
import script from "./experience.vue?vue&type=script&lang=ts"
export * from "./experience.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconCalendar: require('/vercel/path0/components/ui/icon/calendar.vue').default,UiIconClockHand: require('/vercel/path0/components/ui/icon/clock-hand.vue').default,UiIconPeople: require('/vercel/path0/components/ui/icon/people.vue').default})
